import { Instagram, Facebook, Phone, MapPin, Smartphone } from "lucide-react";
import { Logo } from "./Logo";
import { NAV_LINKS, ADDRESS, PHONE_DISPLAY, PHONE_TEL, MOBILE_DISPLAY, MOBILE_TEL, INSTAGRAM_URL, FACEBOOK_URL } from "../data/content";
import { scrollToId } from "../lib/lenis";

export const Footer = () => (
  <footer className="relative bg-ink text-cream grain overflow-hidden" data-testid="site-footer">
    <div className="container-x relative py-16 md:py-20">
      <div className="grid gap-12 md:grid-cols-12">
        <div className="md:col-span-5">
          <Logo light />
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-cream/60">
            Centro estetico a Reschigliano di Campodarsego: cosmesi biologica viso-corpo, massaggi, epilazione laser e brasiliana, filo orientale,
            manicure e pedicure. Bellezza che nasce dal benessere.
          </p>
          <div className="mt-6 flex gap-3">
            <a href={INSTAGRAM_URL} target="_blank" rel="noreferrer" aria-label="Instagram" className="flex h-10 w-10 items-center justify-center rounded-full border border-cream/15 text-cream/80 transition-[background-color,color] hover:bg-gold hover:text-white" data-testid="footer-instagram-link"><Instagram className="h-4 w-4" /></a>
            <a href={FACEBOOK_URL} target="_blank" rel="noreferrer" aria-label="Facebook" className="flex h-10 w-10 items-center justify-center rounded-full border border-cream/15 text-cream/80 transition-[background-color,color] hover:bg-gold hover:text-white" data-testid="footer-facebook-link"><Facebook className="h-4 w-4" /></a>
          </div>
        </div>
        <div className="md:col-span-3">
          <h4 className="text-[11px] uppercase tracking-[0.28em] text-gold-light">Link rapidi</h4>
          <ul className="mt-5 space-y-3">
            {NAV_LINKS.map((l) => (
              <li key={l.id}>
                <button onClick={() => scrollToId(l.id)} className="text-sm text-cream/70 transition-colors hover:text-cream" data-testid={`footer-link-${l.id}`}>{l.label}</button>
              </li>
            ))}
            <li><a href={PHONE_TEL} className="text-sm text-cream/70 transition-colors hover:text-cream" data-testid="footer-link-prenota">Prenota (chiama)</a></li>
          </ul>
        </div>
        <div className="md:col-span-4">
          <h4 className="text-[11px] uppercase tracking-[0.28em] text-gold-light">Contatti</h4>
          <ul className="mt-5 space-y-3 text-sm text-cream/70">
            <li className="flex items-start gap-3"><MapPin className="mt-0.5 h-4 w-4 shrink-0 text-gold-light" /> {ADDRESS}</li>
            <li><a href={PHONE_TEL} className="flex items-center gap-3 hover:text-cream transition-colors" data-testid="footer-phone-link"><Phone className="h-4 w-4 text-gold-light" /> {PHONE_DISPLAY}</a></li>
            <li><a href={MOBILE_TEL} className="flex items-center gap-3 hover:text-cream transition-colors" data-testid="footer-mobile-link"><Smartphone className="h-4 w-4 text-gold-light" /> {MOBILE_DISPLAY}</a></li>
          </ul>
          <p className="mt-6 text-xs leading-relaxed text-cream/40">Mar–Ven 9:00–19:00 · Sab 9:00–15:00 · Dom e Lun chiuso</p>
        </div>
      </div>
      <div className="mt-14 flex flex-col gap-3 border-t border-cream/10 pt-7 text-xs text-cream/40 md:flex-row md:items-center md:justify-between">
        <span data-testid="footer-copyright">© {new Date().getFullYear()} Centro Estetico Biovital · Tutti i diritti riservati</span>
        <span>Centro Estetico Campodarsego · Estetista Reschigliano · Padova</span>
      </div>
    </div>
  </footer>
);
